import { AxiosInstance } from "axios";

import { ResponseType } from "@/types/api";
import { ContactResType, ContactType, RequestResType, RequestType, TalentResType, TalentType } from "@/types/user";
import { getOrCreateFirstTouchTrafficSource } from "@/utils/trafficSource";

class UserAPI {
  private axios;
  private baseUrl;

  constructor(axios: AxiosInstance, baseUrl: string) {
    this.axios = axios;
    this.baseUrl = baseUrl;
  }

  postRequestList = async (requestForm: RequestType) => {
    // 실제 유입 출처(first-touch)를 함께 보낸다. snake_case 키라 백엔드 camel-case
    // 파서를 그대로 통과한다. 값이 없으면(null) 백엔드가 "미수집"으로 처리한다.
    const body = { ...requestForm, traffic_source: getOrCreateFirstTouchTrafficSource() };
    const response = await this.axios.post<ResponseType<RequestResType>>(`${this.baseUrl}/list-request`, body);
    return response.data;
  };

  postContact = async (contactForm: ContactType) => {
    const response = await this.axios.post<ResponseType<ContactResType>>(`${this.baseUrl}/request`, contactForm);
    return response.data;
  };

  postTalent = async (talentForm: TalentType) => {
    const response = await this.axios.post<ResponseType<TalentResType>>(`${this.baseUrl}/talent`, talentForm);
    return response.data;
  };
}

export default UserAPI;
